// extracted by mini-css-extract-plugin
export default {"portada":"Portada_portada__bNb5l"};